const home = [
  {
    path: '/home',
    name: 'First',
    component: () => import('@/views/Home/Home'),
    meta: {
      title: '首页',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/regard',
    name: 'Regard',
    component: () => import('@/views/Regard/Regard'),
    meta: {
      title: '关于我们',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/newcenter',
    name: 'Newcenter',
    component: () => import('@/components/News/newsCenter'),
    meta: {
      title: '新闻中心',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('@/views/Services/Services'),
    meta: {
      title: '服务范围',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    // redirect: '/contact/map',
    component: () => import('@/views/Contact/Contact'),
    meta: {
      title: '联系我们',
      content: {
        keywords: '',
        description: ''
      }
    },
    children: [
      {
        path: '/map',
        name: 'Map',
        component: () => import('@/components/Map/map')
      }
    ]
  },
  {
    path: '/newShow',
    name: 'newShow',
    component: () => import('@/components/News/newShow')
  }
]

export default home
